import $ from "jquery";

const SELECTOR_FILTER_FORM = 'form[id*="views-exposed-form-"]';
const SELECTOR_FORM_SORT = 'select[id*="edit-sort-by"]';
const SELECTOR_FORM_ORDER = 'select[id*="edit-sort-order"]';
const SELECTOR_FORM_RESET = 'input[id*="edit-reset"]';
const SELECTOR_SORT = '.c-search__sort select[id*="edit-sort-by"]';
const SELECTOR_RESET = ".c-filters--reset";
const SELECTOR_FILTER_TAG = '[data-js="jsRemoveFilter"]';

// Take the updated sort field on the search and apply it to the exposed form sort
$(document).on("change", SELECTOR_SORT, function (event) {
  const sort = this.value;
  $(SELECTOR_FORM_ORDER, SELECTOR_FILTER_FORM).val("ASC");
  $(SELECTOR_FORM_SORT, SELECTOR_FILTER_FORM).val(sort).trigger("change");
});

// Take the clear all link and simulate a form submission
$(document).on("click", SELECTOR_RESET, function (event) {
  event.preventDefault();
  $(SELECTOR_FORM_RESET, SELECTOR_FILTER_FORM).trigger("click");
});

$(document).on("click", SELECTOR_FILTER_TAG, function (event) {
  event.preventDefault();
  const filterKey = this.getAttribute("data-filter-key");
  const currentField = $(SELECTOR_FILTER_FORM).find(`input[id|=${filterKey}]`);
  currentField.trigger("click");
});

const expandCheckboxFilters = function () {
  $(".c-search-form__nested-checkbox-title").each(function () {
    const $parent = $(this);
    const $body = $parent.next(".c-search-form__nested-checkbox-body");

    if ($body.find('input[type="checkbox"]:checked').length) {
      $parent.attr("aria-expanded", true);
      $body.removeAttr("hidden");
    }
  });
};

if (window.Drupal) {
  window.Drupal.behaviors.filter = {
    attach() {
      expandCheckboxFilters();
    },
  };
} else {
  $(function () {
    expandCheckboxFilters();
  });
}
